export const formatPrice = (number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "USD",
  }).format(number);
};

export const mobileValidate = (number) => {
  const regexpMobile = /^[0-9\b]+$/;
  if (number === "" || regexpMobile.test(number)) {
    return true;
  }
  return false;
};
export const emailValidate = (emailid) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(emailid)) {
    return true;
  }
  return false;
};
export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);
  if (type === "colors") {
    unique = unique.flat();
  }
  return ["all", ...new Set(unique)];
};
export const getUniqueValuesHome = (data, type) => {
  let unique = data.map((item) => item[type]);
  if (type === "colors") {
    unique = unique.flat();
  }
  return [...new Set(unique)];
};

export const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

/**
 * Parses supply length in months from a product_name.
 * Defaults to 1 when parsing fails.
 * e.g. "Semaglutide - 3 months supply" → 3
 */
export const getSupplyMonthsFromProductName = (productName) => {
  if (!productName || typeof productName !== "string") {
    return 1;
  }

  const match = productName.match(/(\d+)\s*months?/i);
  if (!match) {
    return 1;
  }

  const months = parseInt(match[1], 10);
  if (!months || Number.isNaN(months)) {
    return 1;
  }

  return months;
};

/**
 * Returns disclaimer wording derived from product_name.
 * 1 month keeps monthly copy; 3/6/12 use multi-month supply wording.
 */
export const getDisclaimerSupplyCopy = (productName) => {
  const months = getSupplyMonthsFromProductName(productName);
  const isMonthly = months === 1;

  return {
    months,
    isMonthly,
    supplyLabel: isMonthly ? "1 month supply" : `${months} months supply`,
    packageLabel: isMonthly ? "monthly package" : `${months}-month package`,
    starterKitLabel: isMonthly
      ? "1 month starter kit"
      : `${months} month starter kit`,
    checkInLabel: isMonthly
      ? "Each month,"
      : "At the end of your current supply period,",
  };
};
